import React, { useState, useEffect } from "react";
import "./BannerSlider.css";

export default function BannerSlider({ slides = [], height = 500 }) {
    const [current, setCurrent] = useState(0);

    useEffect(() => {
        if (slides.length <= 1) return;
        const timer = setInterval(() => {
            setCurrent(c => (c + 1) % slides.length);
        }, 5000);
        return () => clearInterval(timer);
    }, [slides.length]);

    if (!slides.length) return null;

    return (
        <div className="banner-slider" style={{ height: `${height}px` }}>
            {slides.map((slide, i) => (
                <div key={i} className={`banner-slide ${i === current ? "active" : ""}`}>
                    <img 
                        src={slide.imageUrl} 
                        alt={slide.title} 
                        style={{ 
                            objectFit: slide.objectFit || "cover", 
                            objectPosition: slide.objectPosition || "center" 
                        }} 
                    />
                    <div className="banner-overlay">
                        {slide.title && <h2 className="banner-title">{slide.title}</h2>}
                        {slide.subtitle && <p className="banner-subtitle">{slide.subtitle}</p>}
                        {slide.buttonText && slide.buttonLink && (
                            <a href={slide.buttonLink} className="btn-primary banner-btn">
                                {slide.buttonText}
                            </a>
                        )}
                    </div>
                </div>
            ))}
            <div className="banner-dots">
                {slides.map((_, i) => (
                    <button
                        key={i}
                        className={`dot ${i === current ? "active" : ""}`}
                        onClick={() => setCurrent(i)}
                        aria-label={`Go to slide ${i + 1}`}
                    />
                ))}
            </div>
            {slides.length > 1 && (
                <>
                    <button className="banner-arrow prev" onClick={() => setCurrent(c => (c - 1 + slides.length) % slides.length)}>‹</button>
                    <button className="banner-arrow next" onClick={() => setCurrent(c => (c + 1) % slides.length)}>›</button>
                </>
            )}
        </div>
    );
}